import { useCallback } from 'react';
import { useCadastroProducao } from './useCadastroProducao';

interface useHandleFocus {
  handleInputFocus: (elementName: string) => void;
}

export const useHandleFocus = (): useHandleFocus => {
  const { containerRef } = useCadastroProducao();

  const handleInputFocus = useCallback(
    (elementName: string) => {
      if (!containerRef.current) return;

      const inputElement: HTMLInputElement | null =
        containerRef.current?.querySelector(`[name="${elementName}"]`);

      if (!inputElement) return;

      setTimeout(() => {
        inputElement.focus();
        if (inputElement.value && inputElement.type !== 'file')
          inputElement.select();
      }, 200);
    },
    [containerRef],
  );

  return { handleInputFocus };
};
